<template>
	<div>		<el-card class="box-card">
			<div class="summary-section">
				<div class="summary-header">
					<span class="summary-title">分账金额统计</span>
					<div class="summary-filter">
						<el-date-picker v-model="summaryDateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleSummaryDateChange" size="small"
							style="width: 240px;">
						</el-date-picker>
					</div>
				</div>
				<div class="summary-cards">
					<div class="summary-card">
						<div class="card-icon pre-money">
							<i class="el-icon-wallet"></i>
						</div>
						<div class="card-content">
							<div class="card-label">预存总金额</div>
							<div class="card-value">¥{{ summary.totalPreMoney || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon cost-money">
							<i class="el-icon-shopping-cart-2"></i>
						</div>
						<div class="card-content">
							<div class="card-label">消费总金额</div>
							<div class="card-value">¥{{ summary.totalCostMoney || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon back-money">
							<i class="el-icon-refresh-left"></i>
						</div>
						<div class="card-content">
							<div class="card-label">退回总金额</div>
							<div class="card-value">¥{{ summary.totalBackMoney || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon split-amount">
							<i class="el-icon-money"></i>
						</div>
						<div class="card-content">
							<div class="card-label">分账总金额</div>
							<div class="card-value">¥{{ summary.totalSplitAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon refund-amount">
							<i class="el-icon-refresh-right"></i>
						</div>
						<div class="card-content">
							<div class="card-label">分账回退金额</div>
							<div class="card-value danger">¥{{ summary.totalRefundAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon success-amount">
							<i class="el-icon-circle-check"></i>
						</div>
						<div class="card-content">
							<div class="card-label">分账成功金额</div>
							<div class="card-value success">¥{{ summary.successSplitAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon actual-amount">
							<i class="el-icon-wallet"></i>
						</div>
						<div class="card-content">
							<div class="card-label">实际到账金额</div>
							<div class="card-value primary">¥{{ summary.actualSplitAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon pending-amount">
							<i class="el-icon-time"></i>
						</div>
						<div class="card-content">
							<div class="card-label">待分账金额</div>
							<div class="card-value warning">¥{{ summary.pendingSplitAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon failed-amount">
							<i class="el-icon-circle-close"></i>
						</div>
						<div class="card-content">
							<div class="card-label">分账失败金额</div>
							<div class="card-value danger">¥{{ summary.failedSplitAmount || '0.00' }}</div>
						</div>
					</div>
					<div class="summary-card">
						<div class="card-icon total-count">
							<i class="el-icon-document"></i>
						</div>
						<div class="card-content">
							<div class="card-label">记录总数</div>
							<div class="card-value info">{{ summary.totalCount || 0 }} 条</div>
						</div>
					</div>
				</div>
			</div>
			
			<el-divider></el-divider>
			
			<div style="margin-bottom: 20px;">
				<el-form ref="pageInfoReq" :model="pageInfoReq" label-width="80px" inline size="small">
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="pageInfoReq.distributorId" placeholder="请选择" clearable filterable
							style="width: 150px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号:">
						<el-input :clearable=true v-model="pageInfoReq.memberMobile" placeholder="请输入手机号"
							style="width: 120px;" />
					</el-form-item>
					<el-form-item label="保单号:">
						<el-input :clearable=true v-model="pageInfoReq.itemNumber" placeholder="请输入保单号"
							style="width: 120px;" />
					</el-form-item>
					<el-form-item label="分账状态:">
						<el-select v-model="pageInfoReq.splitStatus" placeholder="请选择" clearable style="width: 120px;">
							<el-option v-for="item in splitStatusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分账时间:">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;margin-left: 8px;"
							@click="reGetList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="dataList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="手机号" prop="memberMobile" width="110"></el-table-column>
				<el-table-column label="运营商" prop="distributorName" width="120"></el-table-column>
				<el-table-column label="订单号" prop="srcTradNo" width="180" show-overflow-tooltip></el-table-column>
				<el-table-column label="预存金额" prop="preMoney" width="100">
					<template slot-scope="scope">
						<span style="color: #67C23A; font-weight: bold;">¥{{ scope.row.preMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="消费金额" prop="costMoney" width="100">
					<template slot-scope="scope">
						<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.costMoney || '0.00' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="退回金额" prop="backMoney" width="100">
					<template slot-scope="scope">
						<span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.backMoney || '0.00' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="预存状态" prop="status" width="100">
					<template slot-scope="scope">
						<el-tag :type="getStatusType(scope.row.status)">
							{{ getStatusDesc(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="分账目标" prop="splitTargetName" width="100"></el-table-column>
				<el-table-column label="分账比例" prop="splitRatio" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.splitRatio">{{ (scope.row.splitRatio * 100).toFixed(2) }}%</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="分账金额" prop="splitAmount" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.splitAmount" style="color: #409EFF; font-weight: bold;">¥{{ scope.row.splitAmount }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="回退金额" prop="refundAmount" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.refundAmount && scope.row.refundAmount > 0" style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.refundAmount }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="分账状态" prop="splitStatus" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.splitStatus !== null" :type="getSplitStatusType(scope.row.splitStatus)">
							{{ getSplitStatusDesc(scope.row.splitStatus) }}
						</el-tag>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="分账类型" prop="splitType" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.splitType !== null">{{ getSplitTypeDesc(scope.row.splitType) }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="微信分账单号" prop="transactionId" width="180" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.transactionId">{{ scope.row.transactionId }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="分账失败原因" prop="failReason" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.failReason" style="color: #F56C6C;">{{ scope.row.failReason }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="分账时间" prop="splitTime" width="150">
					<template slot-scope="scope">
						<span v-if="scope.row.splitTime">{{ scope.row.splitTime }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="pageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			user: '',
			isAdmin: false,
			dateRange: [],
			summaryDateRange: [],
			distributorOptions: [],
			statusOptions: [{
				key: 0,
				value: '已退款'
			}, {
				key: 1,
				value: '未退款'
			}, {
				key: 2,
				value: '已消费'
			}, {
				key: 3,
				value: '消费已退款'
			}, {
				key: 4,
				value: '消费未退款'
			}, {
				key: 5,
				value: '执行退款中'
			}],
			splitStatusOptions: [{
				key: 0,
				value: '待分账'
			}, {
				key: 1,
				value: '分账成功'
			}, {
				key: 2,
				value: '分账失败'
			}],
			splitTypeOptions: [{
				key: 1,
				value: '平台方'
			}, {
				key: 2,
				value: '商户方'
			}, {
				key: 3,
				value: '其他方'
			}],
			pageInfoReq: {
				page: 1,
				limit: 8,
				memberName: '',
				memberMobile: '',
				itemNumber: '',
				srcTradNo: '',
				distributorId: '',
				status: '',
				splitStatus: '',
				splitType: '',
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			},
			summaryReq: {
				queryDistributorId: '',
				startDate: '',
				endDate: '',
				splitStatus: '',
				splitType: ''
			},
			summary: {
				totalPreMoney: '0.00',
				totalCostMoney: '0.00',
				totalBackMoney: '0.00',
				totalSplitAmount: '0.00',
				totalRefundAmount: '0.00',
				successSplitAmount: '0.00',
				actualSplitAmount: '0.00',
				pendingSplitAmount: '0.00',
				failedSplitAmount: '0.00',
				totalCount: 0
			},
			dataList: [],
			total: 0,
		}
	},
	created() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.getDistributorOptions();
		this.pageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.summaryReq.queryDistributorId = getCurrentDistributorId()
		this.getSummary();
		this.getList();
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.pageInfoReq.queryDistributorId = distributorId || ''
			this.summaryReq.queryDistributorId = distributorId || ''
			this.pageInfoReq.page = 1
			this.getSummary()
			this.getList()
		},
		async getSummary() {
			const { data: res } = await this.$http.post(
				'/member/premoney/getSplitAccountSummary', this.summaryReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.summary = res.data
		},
		handleSummaryDateChange(val) {
			if (val) {
				this.summaryReq.startDate = val[0];
				this.summaryReq.endDate = val[1];
			} else {
				this.summaryReq.startDate = '';
				this.summaryReq.endDate = '';
			}
			this.getSummary();
		},
		async getList() {
			const { data: res } = await this.$http.post(
				'/member/premoney/getSplitAccountDetailPage', this.pageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.dataList = res.data.list
			this.total = res.data.total
		},
		reGetList() {
			this.pageInfoReq.page = 1;
			this.getList();
		},
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
			});
		},
		handleDateChange(val) {
			if (val) {
				this.pageInfoReq.startDate = val[0];
				this.pageInfoReq.endDate = val[1];
			} else {
				this.pageInfoReq.startDate = '';
				this.pageInfoReq.endDate = '';
			}
		},
		handleSizeChange(pageSize) {
			this.pageInfoReq.limit = pageSize
			this.getList()
		},
		handleCurrentChange(pageNum) {
			this.pageInfoReq.page = pageNum
			this.getList()
		},
		getStatusDesc(status) {
			switch (status) {
				case 0: return '已退款';
				case 1: return '未退款';
				case 2: return '已消费';
				case 3: return '消费已退款';
				case 4: return '消费未退款';
				case 5: return '执行退款中';
				default: return '未知';
			}
		},
		getStatusType(status) {
			switch (status) {
				case 0: return 'success';
				case 1: return 'primary';
				case 2: return 'warning';
				case 3: return 'success';
				case 4: return 'danger';
				case 5: return 'info';
				default: return 'info';
			}
		},
		getSplitStatusDesc(status) {
			switch (status) {
				case 0: return '待分账';
				case 1: return '分账成功';
				case 2: return '分账失败';
				default: return '未知';
			}
		},
		getSplitStatusType(status) {
			switch (status) {
				case 0: return 'warning';
				case 1: return 'success';
				case 2: return 'danger';
				default: return 'info';
			}
		},
		getSplitTypeDesc(type) {
			switch (type) {
				case 1: return '平台方';
				case 2: return '商户方';
				case 3: return '其他方';
				default: return '未知';
			}
		},
	}
}
</script>

<style scoped>
.el-card {
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.el-table {
	margin-top: 15px;
	font-size: 12px;
}

.el-pagination {
	margin-top: 15px;
}

.summary-section {
	margin-bottom: 20px;
}

.summary-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
}

.summary-title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
}

.summary-filter {
	display: flex;
	align-items: center;
}

.summary-cards {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 15px;
}

.summary-card {
	display: flex;
	align-items: center;
	padding: 15px;
	background: #f5f7fa;
	border-radius: 8px;
	transition: all 0.3s;
}

.summary-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-icon {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
	font-size: 24px;
	color: #fff;
}

.card-icon.pre-money {
	background: linear-gradient(135deg, #67C23A, #85ce61);
}

.card-icon.cost-money {
	background: linear-gradient(135deg, #E6A23C, #f0c78a);
}

.card-icon.back-money {
	background: linear-gradient(135deg, #F56C6C, #fab6b6);
}

.card-icon.split-amount {
	background: linear-gradient(135deg, #409EFF, #a0cfff);
}

.card-icon.refund-amount {
	background: linear-gradient(135deg, #F56C6C, #fab6b6);
}

.card-icon.success-amount {
	background: linear-gradient(135deg, #67C23A, #85ce61);
}

.card-icon.actual-amount {
	background: linear-gradient(135deg, #409EFF, #a0cfff);
}

.card-icon.pending-amount {
	background: linear-gradient(135deg, #E6A23C, #f0c78a);
}

.card-icon.failed-amount {
	background: linear-gradient(135deg, #F56C6C, #fab6b6);
}

.card-icon.total-count {
	background: linear-gradient(135deg, #909399, #c0c4cc);
}

.card-content {
	flex: 1;
}

.card-label {
	font-size: 12px;
	color: #909399;
	margin-bottom: 5px;
}

.card-value {
	font-size: 18px;
	font-weight: bold;
	color: #303133;
}

.card-value.success {
	color: #67C23A;
}

.card-value.warning {
	color: #E6A23C;
}

.card-value.danger {
	color: #F56C6C;
}

.card-value.primary {
	color: #409EFF;
}

.card-value.info {
	color: #909399;
}
</style>
